module.exports = __webpack_public_path__ + "img/num_25.116fd235.png";